import Layer from './Layer';
import { toDate } from '../utils';
import moment from 'moment';

// 高解像度降水ナウキャスト
export default class HighResolutionNowcast extends Layer {
    _latest = process.env.REACT_APP_HIGHRESOLUTIONNOWCAST_URL;

    constructor() {
        const id = 'highResolutionNowcast';
        const layers = {
            'highResolutionNowcast-mesh': {
                type: 'mesh',
                source: id,
            },
        };

        const paintOptions = {
            'highResolutionNowcast-mesh': {
                'raster-opacity': 0.6
            },
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'highResolutionNowcast', layers: ['highResolutionNowcast-mesh'], isShow: true },
        ];

        super(id, layers, paintOptions, elements);
    }

    set latest(latest) { this._latest = latest; }
    get latest() { return this._latest; }

    setDemoUrl(datetime) {
        const YYYYMMDDHHmm = moment(datetime).utc().format("YYYYMMDDHHmm");
        this._latest = `${process.env.REACT_APP_HIGHRESOLUTIONNOWCAST_DEMO_URL}/${YYYYMMDDHHmm}/tile.json`
    };

    async add() {
        return fetch(this._latest)
            .then(res => res.json())
            .then(json => {

                let url = '';
                if (this.isDemo) {
                    url = json.tiles[0].url;

                } else {
                    json.hires.tiles.forEach(x => {
                        if (x.type === 'now') {
                            url = x.url;
                        }
                    })
                }

                this.map.addSource(this.id, {
                    type: 'mesh',
                    tiles: [url],
                    bounds: [[118.0, 20.0], [150.0, 48.0]],
                    tileSize: [320, 420],
                    tileZoom: [1, 2, 3, 4, 5]
                });

                Object.keys(this.layers)
                    .map(x =>
                        this.map.addLayer({ id: x, ...this.layers[x], paint: { ...this._paintOptions[x] } })
                    );

                this.datetime = toDate(this.isDemo ? json.ref_time : json.hires.ref_time);
                console.log(`loaded HighResolutionNowcast ${this.datetime}`)
            });
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }
};


